module.exports = __webpack_public_path__ + "0687d2a0708582baea57e961d2131b6a.svg";